//Menu
export const SELECT_TABS = "SELECT_TABS";
export const SET_SELECTED = "SET_SELECTED";
export const SET_DEFAULT_TABS = "SET_DEFAULT_TABS";
export const TOGGLE_SETTINGS = "TOGGLE_SETTINGS";
export const SET_TOOLS_TABS = "SET_TOOLS_TABS";
export const SET_TABS_DATA = "SET_TABS_DATA";
export const SET_ORGANIZATION_TABS = "SET_ORGANIZATION_TABS";
